import React, { useEffect, useState } from "react";
import './UpsaleActivity.css'
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import RadioChecked from "../../svg/radioChecked";
import RadioEmpty from "../../svg/radioEmpty";

export default function UpsaleActivity(props) {

    const [selectedCampaign, setSelectedCampaign] = useState(undefined);
    const [selectedCheckb, setSelectedCheckb] = useState(4);
    const store = useSelector(store => store.reducer);
    const { activityHours, ...upsaleData } = props.upsaleActivities || {};
    const extraPayment = ((props.visitors?.adults || 0) * (upsaleData.price?.adults || 0)) + ((props.visitors?.underAge || 0) * (upsaleData.price?.underAge || 0))
    //const ageStr = (props.kindergarden__c && props.school__c) ? 'גילאי 4-12' : props.kindergarden__c ? 'גילאי 4-7' : props.school__c ? 'גילאי 7-12' : '';
    const handleCheckBoxClick = (item) => {
        setSelectedCheckb(item.Id)
        setSelectedCampaign(item) 
    }

    return <div className="card activityDetailCard border-0 rounded-0 mt-2">

                <div className="text-start">
                    <button onClick={() => props.onClose()} className=' btn btn-icon'>
                        <i className="exit-shape icon-close close" />
                    </button>
                </div>
                {isMobile ? <div className="pt-2">
                    <div className="px-3">
                        <h4 className="almoni_tzar_normal text-start">מומלץ לשלב בביקור פעילות נוספת:</h4>
                        <div className="row gx-lg-4 gx-3 mt-3 mb-4">
                            <div className="col-3 col-lg-3">
                                <img className=" card-img border-0" src={props.upsaleActivities?.cart_picture__c} alt="cart-img" />
                            </div>
                            <div className="col-9 col-lg-9">
                                <div className="alef">
                                    <div className="text-start text-mahuti fw-bold">{props.upsaleActivities?.Title || ''}</div>
                                    <div className="text-start">{props.upsaleActivities?.Subtitle || ''}</div>
                                </div>
                            </div>
                        </div>
                        <hr className="gray_separator"/>
                        <h4 className="almoni_tzar_normal text-start">בחרו שעה</h4>
                        {activityHours && activityHours.map((item, index) => <div key={'activityHours_' + item.Id} className={`d-flex pt-3 gap-4 align-items-center pb-3 ${index !== activityHours.length - 1 ? 'bottom_separator' : ''}`}>
                                <input className="text-mahuti upsale_radio invisible position-absolute" type='radio' name={'activitydetailcardtimes'} id={'activitydetailcardtimes_' + item.Id}
                                    onChange={() => { handleCheckBoxClick(item) }} />
                                <label className="text-mahuti" htmlFor={'activitydetailcardtimes_' + item.Id}>
                                    {selectedCheckb === item.Id ? <RadioChecked/> : <RadioEmpty/>} <span className="ms-2">{item.startTime} - {item.endTime}</span>
                                </label>
                            </div>
                            )}
                    </div>
                    <div className="almoni_tzar_bold text-end px-3 py-lg-2">
                        תוספת מחיר: {extraPayment}₪
                    </div>
                    <div className="col-lg-7 col-12 d-flex justify-content-end pb-lg-5 pb-0">
                        <div id="stepperBtns" className="d-flex justify-content-end py-2 my-1">
                            <button className="btn-link prev btn step_btn almoni_tzar_normal text-decoration-none" onClick={(e) => { e.preventDefault(); props.onClose() }}>לא, תודה</button> 
                            <button 
                                className={`${selectedCampaign ? "btn-primary " : 'btn-disabled'} btn step_btn`} 
                                disabled={!selectedCampaign || store.isStepFourLoading} 
                                onClick={(e) => { e.preventDefault(); props.addToCart({ ...upsaleData, campaignId: selectedCampaign.campaignId, timing: selectedCampaign, visitors: { ...props.visitors } }, true) }}>
                                    <span className="almoni_tzar_normal">הוסף והמשך</span>
                                    {(store.isStepFourLoading) && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                            </button>
                        </div>
                    </div>
                </div> :
                <><div className="card-body row">
                    <div className="col-6">
                        <div className="card-title">
                            {upsaleData ?
                                'מומלץ לשלב בביקור פעילות נוספת:'
                                :
                                'פעילות'}
                        </div>
                        <div className="upsale-info py-2">
                            <h5 className="header-details  d-flex justify-content-start">{props.upsaleActivities?.Title || ''}</h5> 
                            <span className="card-subtitle text-mahuti-bold mb-2 d-flex justify-content-start">{props.upsaleActivities?.Subtitle || ''}</span>
                            <p className=" text-mahuti description d-flex justify-content-start text-start">{props.upsaleActivities?.shortDescription__c || ''}</p>
                        </div>

                        <div className="flex-column pt-4">
                            {activityHours && <h5 className="header-details d-flex justify-content-start ">בחרו שעה</h5>}

                            {activityHours && activityHours.map(item => <div key={'activityHours_' + item.Id} className="d-flex pt-3 gap-4 align-items-center">
                                <input className="text-mahuti invisible position-absolute" type='radio' name={'activitydetailcardtimes'} id={'activitydetailcardtimes_' + item.Id}
                                    onChange={() => { handleCheckBoxClick(item)}} />
                                <label className="text-mahuti pointer" htmlFor={'activitydetailcardtimes_' + item.Id}>
                                    {selectedCheckb === item.Id ? <RadioChecked/> : <RadioEmpty/>} <span className="ms-2">{item.startTime} - {item.endTime}</span>
                                </label>
                            </div>
                            )}
                        </div>
                    </div>

                    <div className="col-6 d-flex justify-content-end">
                        <div className="d-flex align-items-end flex-column">
                            <div className="col">
                                <img className="img-thumbnail border-0 rounded-3" src={props.upsaleActivities?.cart_picture__c} alt="cap" />
                            </div>
                            {/* <div className="align-text-bottom p-1">
                                <a href="/" className="btn btn-link text-mahuti">נקה בחירה</a>
                            </div> */}
                        </div>
                    </div>
                </div>
                <hr />

                <div className="card-footer justify-content-between header-detail d-flex bg-body border-0 fw-bold pl-4 align-items-center">
                    <div className="extra-payment">
                        תוספת מחיר: {extraPayment}
                    </div>
                    <div className="">
                        <Link className="btn-link p-3" onClick={(e) => { e.preventDefault(); props.onClose() }}>לא תודה</Link>
                        <button 
                        className={selectedCampaign ? "btn-primary " : 'btn-disabled'} 
                        disabled={!selectedCampaign || store.isStepFourLoading} 
                        onClick={(e) => { e.preventDefault(); props.addToCart({ ...upsaleData, campaignId: selectedCampaign.campaignId, timing: selectedCampaign, visitors: { ...props.visitors } }, true) }}>
                            <span>הוסף והמשך לרכישה</span>
                            {(store.isStepFourLoading) && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                        </button>
                    </div>

                </div></>}

            </div>
}